import { render, staticRenderFns } from "./DetailInformation.vue?vue&type=template&id=9fd223a6&scoped=true"
import script from "./DetailInformation.vue?vue&type=script&lang=js"
export * from "./DetailInformation.vue?vue&type=script&lang=js"
import style0 from "./DetailInformation.vue?vue&type=style&index=0&id=9fd223a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd223a6",
  null
  
)

export default component.exports